const TENANT_ID = 'Showtime';
export default TENANT_ID;
export const ADMIN_TENANT_ID = 'AtoZMobile';
export function isAdminTenant(tenantId) {
    return tenantId === ADMIN_TENANT_ID;
}
//# sourceMappingURL=TenantId.js.map